const computeColor = (text, useAllColors = false) => {
  const colors = [
    ...(useAllColors
      ? [
          '#FFA07A', // Light Salmon
          '#98FB98', // Pale Green
          '#DDA0DD', // Plum
          '#87CEFA', // Light Sky Blue
          '#F0E68C', // Khaki
          '#E6A8D7', // Light Orchid
          '#FFB347' // Pastel Orange
        ]
      : []),

    '#f9d5de', // red
    '#f9ead5', // orange
    '#e7d5f9', // purple
    '#d5f9da' // green
  ];

  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = (hash << 5) - hash + text.charCodeAt(i);
    hash = hash & hash; // Convert to 32-bit integer
  }

  const colorIndex = Math.abs(hash) % colors.length;
  return colors[colorIndex];
};

export default computeColor;
